enum BillingAndSubscriptionsEvents {
  BillingInvoicesView = 'BillingInvoicesView',
  SubscriptionsView = 'SubscriptionsView',
  UsageReportView = 'UsageReportView',
  CostExplorerView = 'CostExplorerView',

  BillingInvoicesClientFilter = 'BillingInvoicesClientFilter',
  BillingInvoicesStatusFilter = 'BillingInvoicesStatusFilter',
  BillingInvoicesSearchFilter = 'BillingInvoicesSearchFilter',
  BillingInvoicesDateFilter = 'BillingInvoicesDateFilter',
  BillingInvoicesCaseFilter = 'BillingInvoicesCaseFilter',
  BillingInvoicesSelectAllVisible = 'BillingInvoicesSelectAllVisible',
  BillingInvoicesPDFExport = 'BillingInvoicesPDFExport',
  BillingInvoicesACHPayment = 'BillingInvoicesACHPayment',
  BillingInvoicesCardPayment = 'BillingInvoicesCardPayment',
  BillingInvoicesBulkPDFExport = 'BillingInvoicesBulkPDFExport',
  BillingInvoicesBulkACHPayment = 'BillingInvoicesBulkACHPayment',
  BillingInvoicesBulkCardPayment = 'BillingInvoicesBulkCardPayment',

  CostExplorerBreakdownSwitch = 'CostExplorerBreakdownSwitch',
  CostExplorerClientFilter = 'CostExplorerClientFilter',
  CostExplorerSubscriptionFilter = 'CostExplorerSubscriptionFilter',
  CostExplorerServiceFilter = 'CostExplorerServiceFilter',
  CostExplorerCaseFilter = 'CostExplorerCaseFilter',
  CostExplorerDateFilter = 'CostExplorerDateFilter',
  CostExplorerShowAllInvoices = 'CostExplorerShowAllInvoices',
  CostExplorerInvoiceClick = 'CostExplorerInvoiceClick'
};

export default BillingAndSubscriptionsEvents;
